import React from 'react';

import {
    HomePageBannerUpsellWrapper,
    HomepageValuePropCTA,
    OnsiteMessage,
} from '@zillow/zrs-cms-messaging';
import { isEmpty } from 'lodash';

import type { getOmpDataQuery } from '../../__generated__/graphql';
import { ompNewLaneProps } from '../../constants/newLane';
import { AllHopsPlacements } from '../../types/genericTypes';

const PLACEMENT_NAME = AllHopsPlacements.HOME_PAGE_TOP_SLOT;
const triggerProps = ompNewLaneProps[PLACEMENT_NAME];

const HomePageTopSlot: React.FC<HomePageTopSlotProps> = ({
    onsiteMessageData = {},
    additionalProps,
}) => {
    if (isEmpty(onsiteMessageData)) {
        return null;
    }

    return (
        <OnsiteMessage
            messageData={onsiteMessageData}
            placementName={PLACEMENT_NAME}
            // eslint-disable-next-line max-len
            // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment, zillow/@typescript-eslint/naming-convention
            supportedComponents={{ HomepageValuePropCTA, HomePageBannerUpsellWrapper }}
            triggerObject={triggerProps.triggerObject}
            triggerLocation={triggerProps.triggerLocation}
            triggerSource={triggerProps.triggerSource}
            additionalProps={additionalProps}
        />
    );
};

interface HomePageTopSlotProps {
    onsiteMessageData: getOmpDataQuery['onsiteMessage'] | undefined;
    additionalProps?: Record<string, unknown>;
}

HomePageTopSlot.defaultProps = {
    additionalProps: {},
};

export default HomePageTopSlot;
